module.exports = __webpack_public_path__ + "img/archive-fill.8ed40fb2.svg";